import Constants from "expo-constants";
import HelperPlatform from 'utils/helper-platform'
import * as Device from 'expo-device';
import _ from 'lodash'

const HelperDevelopment = {
	isDev: () => {
		return !process.env.NODE_ENV || process.env.NODE_ENV === 'development' || Device.isDevice === false ;
	},
	
	isTestOTA: () => {
		return _.includes(Constants?.linkingUri ?? '', 'test-ota' );
	},
	
	isTestWeb: () => {
		return HelperPlatform.isWeb() && _.includes(Constants?.linkingUri ?? '', 'test-' )
	}
}

export default HelperDevelopment
